import React, { useContext } from 'react';
import { AuthContext } from '@dexter-experts/auth-react';

const EXPERT_GROUPS = [
  { title: 'Clinicians & lab leaders', text: 'Frontline perspective on adoption and workflows' },
  { title: 'Industry executives', text: 'Strategic view across biopharma and health tech' },
  { title: 'Scientists & researchers', text: 'Technical depth from industry and academia' },
];

const Landing = () => {
  const { goToAuth } = useContext(AuthContext);

  return (
    <div id="landing">
      <section className="intro">
        <a className="logo" href="https://www.dexterexperts.com">DEXTER</a>
        <div className="content">
          <h1>Welcome to Dexter</h1>
          <p className="tagline">
            Quality expert insights and AI analyses across
            <br />
            life sciences, health tech &amp; precision medicine.
          </p>
          <p className="description">
            Get voice-of-customer feedback, understand product requirements,
            explore a commercial opportunity, or gauge brand awareness through
            1:1 Zoom interviews and online surveys
          </p>
          <button type="button" className="login-btn" onClick={goToAuth}>
            Client Login / Sign up
          </button>
          <div className="expert-login">
            Are you an expert?
            {' '}
            <a href={process.env.REACT_APP_EXPERT_APP_URL}>Expert login →</a>
          </div>
        </div>
      </section>
      <section className="network" aria-label="Our expert network">
        <div className="contact">
          Questions?
          {' '}
          <a href="https://www.dexterexperts.com/contact/inquiry" target="_blank" rel="noopener noreferrer">
            Contact our team
          </a>
        </div>
        <div className="eyebrow">Our expert network</div>
        <div className="subtitle">Thousands of vetted, relevant experts &amp; KOLs, including</div>
        {EXPERT_GROUPS.map(({ title, text }) => (
          <div className="group" key={title}>
            <div className="group-title">{title}</div>
            <div className="group-text">{text}</div>
          </div>
        ))}
        <div className="more">… and more</div>
      </section>
    </div>
  );
};

export default Landing;
